import React from "react"
import * as S from "./elements"
import { ArrowRight, ArrowLeft } from "@components/Icons"
import IntlLink, { IntlLinkProps } from "@components/Intl/IntlLink"

export type Variant = "arrow-right" | "arrow-left"
export type Style = "purple-caps" | "regular"

interface Props extends IntlLinkProps {
  variant?: Variant
  styling?: Style
}

export const ArrowLink: React.FC<Props> = ({
  href,
  children,
  variant = "arrow-right",
  styling = "regular",
  as,
}) => {
  return (
    <IntlLink href={href} as={as}>
      <S.Anchor
        href={typeof as === "string" ? as : undefined}
        variant={variant}
        styling={styling}
      >
        {variant === "arrow-left" && <ArrowLeft />}
        {children}
        {variant === "arrow-right" && <ArrowRight />}
      </S.Anchor>
    </IntlLink>
  )
}
